<template>
    <div v-if="issue_obj">
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                    label="* Issue ID"
                    readonly
                    class="w-full"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectDate :disabled="mode != 'e'" :selectedDate.sync="issue_obj.data.date" label="Date" />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Direction</label>
                <div class="flex mt-3 align-center">
                    <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="lhs">LHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="rhs" class="mx-3">RHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="bhs" class="mx-3">BHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="median" class="mx-3">Median</vs-radio>
                </div>
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.direction">
                    {{ api_errors.data.direction.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Chainage</label>
                <vs-row class="mt-1">
                    <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                        <div class="flex" style="align-items: center">
                            <label class="vs-input--label block mr-3">From</label>
                            <vs-input
                                v-model="issue_obj.data.chainage_from"
                                class="w-full"
                                :disabled="mode != 'e'"
                            />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_from">
                            {{ api_errors.data.chainage_from.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                        <div class="flex" style="align-items: center">
                            <label class="vs-input--label block mr-3">To</label>
                            <vs-input
                                v-model="issue_obj.data.chainage_to"
                                class="w-full"
                                :disabled="mode != 'e'"
                            />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_to">
                            {{ api_errors.data.chainage_to.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.category"
                    label="Issue Category"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_categories}?issue_type_category=major_maintenance&active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    @change="!issue.id ? issue_obj.data.issue_type = null : null"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.category">
                    {{ api_errors.data.category.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.issue_type"
                    label="Issue Type"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="issue_obj.data.category ? true : false"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_issues_types}?category=${issue_obj.data.category ? issue_obj.data.category.id : null}&active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="!issue_obj.data.category || mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.issue_type">
                    {{ api_errors.data.issue_type.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.authority_type"
                    label="Authority Type"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_authority_types}?active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.authority_type">
                    {{ api_errors.data.authority_type.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    v-model="issue_obj.data.document_or_letter_reference"
                    class="w-full"
                    label="Document/Letter Reference"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.document_or_letter_reference">
                    {{ api_errors.data.document_or_letter_reference.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.assigned_reviewers"
                    label="Select Maintenance Manager"
                    placeholder="Type to Search..."
                    :multiple="true"
                    :load_initial="true"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :close_on_select="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.assigned_reviewers">
                    {{ api_errors.assigned_reviewers.join(', ') }}
                </small>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.sap_po"
                        label="Sap Po"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['po_number', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.sap_po_list}?status=a`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :autoselect_first="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.sap_po">
                        {{ api_errors.data.sap_po.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    <label class="vs-input--label block mb-1">Remarks</label>
                    <vs-textarea v-model="issue_obj.data.remarks" :disabled="mode != 'e'" />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remarks">
                        {{ api_errors.data.remarks.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                    <FileSelection
                        :images.sync="issue_obj.images"
                        :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                        :read_only="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.images">
                        {{ api_errors.images.join(', ') }}
                    </small>
                </vs-col>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                <LocationChooser :disabled="mode != 'e'" :latitude.sync="issue_obj.data.location_latitude" :longitude.sync="issue_obj.data.location_longitude" :api_errors="{latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null}" />
            </vs-col>
        </vs-row>
        <vs-row class="mt-base" v-if="show_action_buttons && show_review && $store.state.is_online">
            <vs-col class="text-center">
                <vs-button @click="$emit('reject')" type="filled" color="primary" class="mx-2">
                    Reject
                </vs-button>
                <vs-button @click="$emit('approve')" type="filled" color="primary" class="mx-2">
                    Approve
                </vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import LocationChooser from '../Components/LocationChooser.vue'
import FileSelection from "../Components/FileSelection.vue"
import SelectDate  from '../../../components/letstream/ls-select-date/SelectDate.vue'

export default {
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        },
        show_action_buttons: {
            required: true,
            type: Boolean
        },
        show_review: {
            required: true,
            type: Boolean
        },
        manager_dropdown: {
            required: true,
            type: Function
        }
    },
    components: {
        FileSelection,
        SelectDate,
        LocationChooser
    },
    data () {
        return {
            issue_obj: null,
            default_data: {
                date: new Date(Date.now()),
                direction: null,
                chainage_from: null,
                chainage_to: null,
                category: null,
                issue_type: null,
                authority_type: null,
                remarks: null,
                document_or_letter_reference: null,
                location_latitude: null,
                location_longitude: null,
                sap_po: null
            },
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        }
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data)
                    issue_obj.data = this.deepclone(this.default_data)
                
                this.issue_obj = issue_obj
            }
        }
    }
}
</script>
